import { useEffect, useState } from "react";

/** A value that follows `value` only after it has rested for `ms`: asked once per pause in typing, not per keystroke.
 * Before the browser runs an effect (and on the server) it is the value as first seen. */
export function useDebounced<T>(value: T, ms: number): T {
  const [rested, setRested] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setRested(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return rested;
}
